import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import HtmlText from "@/sections/common/HtmlText";

// -----------------------------------------------------------------------------------------

export type ICourseOverviewCard = {
  heading?: string;
  subHeading?: string;
  description?: ReactNode;
};

export type ICourseOverviewCardProps = HTMLAttributes<HTMLDivElement> &
  ICourseOverviewCard & {};

const CourseOverviewCard: FC<ICourseOverviewCardProps> = (props) => {
  const { heading, subHeading, description, className, ...other } = props;

  return (
    <div
      className={clsx(
        "col-span-12 w-full bg-primary-100 py-8 pl-5 pr-8 dark:bg-black-800 md:col-span-6 lg:col-span-4 lg:py-10 lg:pl-8 lg:pr-10 xl:py-12 xl:pl-10 xl:pr-12",
        className,
      )}
      {...other}
    >
      {heading && (
        <span className="mb-3 text-base font-normal dark:text-yellow-400 lg:mb-5 lg:text-lg xl:mb-7 xl:text-h6">
          {heading}
        </span>
      )}

      {subHeading && (
        <p className="mb-3 text-h6 font-normal text-black-900 dark:text-white lg:mb-5 lg:text-h5 xl:text-h4">
          {subHeading}
        </p>
      )}

      {description && <HtmlText>{description}</HtmlText>}
    </div>
  );
};

export default CourseOverviewCard;
